import { Box, Button } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useSounds } from 'contexts/Sounds/Sounds';
import { useMemo } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import Info from '../Info/Info';

export default function ResetButton() {
    const game = useGame();
    const page = usePage();
    const sounds = useSounds();

    const { disableResetButton, resetButtonLesson } = game.lessonProps;

    const disabled = useMemo(() => {
        return (
            disableResetButton ||
            (!resetButtonLesson && ((!game.hands && game.round === 'hole') || game.round === 'end'))
        );
    }, [disableResetButton, game.hands, game.round, resetButtonLesson]);

    function handleClick() {
        if (!game.loading && game.ready) {
            sounds.play('submit');
            game.reset(true, !resetButtonLesson);

            if (resetButtonLesson) {
                page.show(resetButtonLesson);
            }
        }
    }

    return (
        <Box position="relative">
            <Button
                color="inherit"
                className="info"
                disabled={disabled}
                startIcon={<MaterialSymbol aria-hidden icon="undo" size={23} />}
                tabIndex={20}
                variant="text"
                onClick={handleClick}
            >
                Reset
            </Button>
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
                paddingX={1}
                position="absolute"
                right={0}
                top={0}
                zIndex={1}
            >
                <Info name="reset" tabIndex={21} />
            </Box>
        </Box>
    );
}
